<template>
  <v-text-field
    :value="localValue"
    @change="newValue => (localValue = newValue)"
    @input="newValue => validate(Number(newValue))"
    :label="label"
    :error-messages="errorMessage"
    :hint="hintMessage"
    persistent-hint
    ref="numberInput"
  >
    <template v-slot:append>
      {{ unit }}
    </template>
    <template v-slot:default>
      default slot
    </template>
  </v-text-field>
</template>

<script>
const _ = require("lodash");
const { unitConverter } = require("../../utils/unitConverter.js");

export default {
  name: "NumberInput",
  props: {
    value: { type: Number, required: true },
    label: { type: String, default: "Number" },
    min: { type: Number, default: null },
    max: { type: Number, default: null },
    enforceMinMax: { type: Boolean, default: false },
    showUnit: { type: String, default: null },
    digitsAfterComma: { type: Number, default: 0 }
  },
  data: function() {
    return {
      errorMessage: "",
      hintMessage: ""
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value.toFixed(this.digitsAfterComma);
      },
      set(localValue) {
        let convertedValue = Number(localValue);
        if (_.isNumber(convertedValue)) {
          this.validate(convertedValue);
        }
        this.$emit("valueChange", convertedValue);
      }
    },
    unit() {
      if (this.showUnit) {
        return unitConverter.lookupUnitLabel(this.showUnit, false);
      } else {
        return "";
      }
    }
  },
  methods: {
    focus() {
      this.$nextTick(() => this.$refs.numberInput.focus());
    },

    reset() {
      this.errorMessage = "";
      this.hintMessage = "";
    },
    validate(newValue) {
      this.$emit("valueInput", newValue);
      if (!_.isNumber(newValue)) {
        this.errorMessage = "Please enter a number";
        this.$emit("valid", false);
        return;
      }
      let convertedValue;
      let min;
      let max;

      convertedValue = newValue;
      min = this.min;
      max = this.max;

      if (!this.enforceMinMax) {
        this.errorMessage = "";
        this.$emit("valid", true);
        return;
      }

      if (convertedValue < min) {
        this.errorMessage = `Value too small, must be greater than or equal to ${min}`;
        this.$emit("valid", false);
        return;
      }
      if (convertedValue > max) {
        this.errorMessage = `Value too big, must be smaller than or equal to ${max}`;
        this.$emit("valid", false);
        return;
      }
      this.errorMessage = "";
      this.$emit("valid", true);

      if (
        Math.abs(
          Number(convertedValue.toFixed(this.digitsAfterComma)) - convertedValue
        ) > 1e-8
      ) {
        this.hintMessage = `The value will be cropped to ${
          this.digitsAfterComma
        } digits after the comma`;
      } else {
        this.hintMessage = "";
      }
    }
  }
};
</script>

<style scoped></style>
